'use client';

import { useDeviceName } from 'lib/api/myRobot';

import { KeyPathParser, useTwinQuerySub } from 'hooks/signalR';

import { type AerialState } from 'lib/generated/proto/aerial_interfaces/msg/AerialState';

/**
 * Subscribe to the full AerialState telemetry for the current robot.
 * Returns real-time data parsed from the Statekeeping SignalR hub.
 *
 * Telemetry key: `${deviceName}:Reported:Aerial:AerialState`
 */
export function useAerialState() {
  const { deviceName } = useDeviceName();

  const { data } = useTwinQuerySub<AerialState>(
    KeyPathParser.AerialState.keyPath(deviceName),
    KeyPathParser.AerialState.parser,
  );

  return { aerialState: data };
}
